import { render, staticRenderFns } from "./EmailOrderModal.vue?vue&type=template&id=42aab553&scoped=true"
import script from "./EmailOrderModal.vue?vue&type=script&lang=js"
export * from "./EmailOrderModal.vue?vue&type=script&lang=js"
import style0 from "./EmailOrderModal.vue?vue&type=style&index=0&id=42aab553&prod&lang=css"
import style1 from "./EmailOrderModal.vue?vue&type=style&index=1&id=42aab553&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42aab553",
  null
  
)

export default component.exports